import { DEFAULT_IMAGE_DETAILS, type BannerProps } from "./Banner.shared";
import { Box } from "../../../../../../mads";

import React from "react";
import { StyleSheet } from "react-native";

const BANNER_ASPECT_RATIO = DEFAULT_IMAGE_DETAILS.width / DEFAULT_IMAGE_DETAILS.height;

const imageStyle: React.CSSProperties = {
  aspectRatio: BANNER_ASPECT_RATIO,
  display: "block",
  height: "auto",
  objectFit: "cover",
  objectPosition: "center",
  width: "100%",
};

/**
 * Web banner optimized for server rendering. A native img exposes the URL to
 * the preload scanner, while CSS aspect-ratio uses the real container width
 * during the first layout without waiting for hydration or image metadata.
 *
 * Scroll-driven transforms are intentionally omitted on web. Embedded surfaces
 * use an outer page's window.scrollY rather than the ViewJob scroll container,
 * which can otherwise initialize the banner at opacity 0. The image's intrinsic
 * width/height attributes reserve its ratio without a measured wrapper height.
 */
export const Banner = ({ url, altText }: BannerProps) => {
  return (
    <Box sx={styles.wrapper} testID="company-banner-wrapper">
      <img
        alt={altText}
        data-testid="company-banner"
        draggable={false}
        fetchPriority="high"
        height={DEFAULT_IMAGE_DETAILS.height}
        loading="eager"
        src={url}
        style={imageStyle}
        width={DEFAULT_IMAGE_DETAILS.width}
      />
    </Box>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    overflow: "hidden",
    width: "100%",
  },
});

export { calculateImageRatio, DEFAULT_IMAGE_DETAILS } from "./Banner.shared";
export type { BannerProps } from "./Banner.shared";
